import { Injectable } from '@angular/core';
import { StorageStrategyResource } from '@infra/storage';
import { StorageAdapter } from '@infra/storage/storage-adapter';

@Injectable({ providedIn: 'root' })
export class PixelResource {
  private cookiesStorage: StorageAdapter;

  constructor(storageStrategyResource: StorageStrategyResource) {
    this.cookiesStorage = storageStrategyResource.create('cookies');
  }

  public getFacebookClick() {
    return this.cookiesStorage.getItem('_fbc');
  }

  public getFacebookPixel() {
    return this.cookiesStorage.getItem('_fbp');
  }

  public getTikTokPixel() {
    return this.cookiesStorage.getItem('_ttp');
  }
}
